import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
const today = ['Saved posts', 'Old class notes', 'Random sequences', 'Planning the night before', 'Repeating familiar classes', 'Starting from a blank page'];
const withSystem = ['Open your library', 'Choose the class', 'Review the structure', 'Adapt if needed', 'Walk into class prepared', 'Teach'];
export function TransformationSection() {
  return <section className="w-full bg-cream py-10 sm:py-14 lg:py-18" aria-labelledby="shift-heading" data-id="element-213" data-mp="2j6iry1duuutp">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-214" data-mp="2e6wd5nidp6is">
        <div className="mx-auto max-w-2xl text-center" data-id="element-215" data-mp="2e51rg6za9adn">
          <div className="flex justify-center" data-id="element-216" data-mp="298umagepo2wr">
            <SectionLabel data-id="element-217" data-mp="295ynyqyybc7s">The shift</SectionLabel>
          </div>
          <h2 id="shift-heading" className="mt-3" data-id="element-218" data-mp="247oqg9pr7zj0">
            <span className="block text-[0.6rem] font-semibold uppercase tracking-label text-muted" data-id="element-219" data-mp="207d48shqtr5f">
              From
            </span>
            <span className="mt-1 block font-serif text-[1.15rem] italic leading-tight text-muted sm:text-2xl" data-id="element-220" data-mp="fa15wv45qusr">
              “What am I teaching next?”
            </span>
            <span className="mt-3 block text-[0.6rem] font-semibold uppercase tracking-label text-gold" data-id="element-221" data-mp="5deo6f74ojuy">
              To
            </span>
            <span className="mt-1 block font-serif text-[1.35rem] font-semibold leading-tight text-forest sm:text-3xl" data-id="element-222" data-mp="acivf0ahs7in">
              “My next class is already ready.”
            </span>
          </h2>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-2.5 sm:gap-4" data-id="element-223" data-mp="12zvgf610879u">
          <div className="flex h-full flex-col rounded-2xl border border-sandDark bg-ivory/70 p-4 text-center sm:p-6" data-id="element-224" data-mp="ozu8j6mbnzkv">
            <h3 className="text-[0.6rem] font-semibold uppercase tracking-label text-muted" data-id="element-225" data-mp="t0w8xqrz6hof">
              Today
            </h3>
            <ul className="mt-3 space-y-2" data-id="element-226" data-mp="39th5q31s48we">
              {today.map(item => <li key={item} className="flex flex-col items-center gap-1" data-id="element-227" data-mp="3dqll1w1anpdf">
                  <XIcon className="h-3 w-3 shrink-0 text-clay" aria-hidden="true" data-id="element-228" data-mp="1k9fwuuohqva0" />
                  <span className="text-[0.8rem] leading-snug text-muted sm:text-[0.9rem]" data-id="element-229" data-mp="1fbxmr0yqma0f">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="flex h-full flex-col rounded-2xl border border-forest/20 bg-ivory p-4 text-center shadow-card sm:p-6" data-id="element-230" data-mp="15kjrx6hqdydm">
            <h3 className="text-[0.6rem] font-semibold uppercase tracking-label text-forest" data-id="element-231" data-mp="11h4z1f8p1nir">
              With Yoga Teacher System™
            </h3>
            <ul className="mt-3 space-y-2" data-id="element-232" data-mp="rmd1ucj0x2oi">
              {withSystem.map(item => <li key={item} className="flex flex-col items-center gap-1" data-id="element-233" data-mp="mn0g5v3w21ni">
                  <CheckIcon className="h-3 w-3 shrink-0 text-forest" aria-hidden="true" data-id="element-234" data-mp="2lz2wiwh7ufwy" />
                  <span className="text-[0.8rem] font-medium leading-snug text-ink sm:text-[0.9rem]" data-id="element-235" data-mp="2h08dpuj90rcu">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-6 text-center font-serif text-[1.05rem] font-semibold uppercase leading-tight text-ink sm:text-2xl" data-id="element-236" data-mp="2thsmf4kfbi5v">
          Less time building classes.
          <span className="block text-forest" data-id="element-237" data-mp="338njl3z7k263">More time actually teaching them.</span>
        </p>
      </div>
    </section>;
}